<template>
    <div class="card" :class="className">
        <slot v-if="cardInfo.title" name="card-header">
            <h3>{{ cardInfo.title }}</h3>
            <div class="card-header link">
                <div class="mask" :class="[`mask-${theme}`]"></div>
                <div class="detail-wrap">
                    <p class="detail">{{ cardInfo.content }}</p>
                </div>
            </div>
        </slot>
        <div v-for="(item, index) in cardInfo.cards" :key="index" class="card-body">
            <div class="link link-light" :class="{ expand: item.expand }" @click="toggleCard(index)">
                <div class="mask"><img :src="getCardImgUrl(index)" :alt="getCardImgUrl(index)" /></div>
                <div class="detail-wrap">
                    <slot name="card-body-title">
                        <h4>{{ item.title }}</h4>
                    </slot>
                    <p v-show="item.expand" class="detail">{{ item.desc }}</p>
                </div>
            </div>
        </div>
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        pageName: { type: String, default: '', require: true },
        theme: { type: String, default: 'green' },
        cardData: { type: Object, default: () => ({}) },
        className: { type: String, default: '' }
    },
    data() {
        return {
            current: 0,
            cardInfo: {
                title: '',
                content: '',
                cards: []
            }
        }
    },
    created() {
        this.cardInfo = {
            ...this.cardInfo,
            ...this.cardData
        }
    },
    methods: {
        getCardImgUrl(idx) {
            const { smallImg, expandImg, expand } = this.cardInfo.cards[idx]
            const fileName = expand ? expandImg : smallImg
            return require(`@/assets/images/sustainable/${this.pageName}/${fileName}`)
        },
        toggleCard(idx) {
            if (this.current === idx) {
                this.cardInfo.cards[idx].expand = !this.cardInfo.cards[idx].expand
            } else {
                this.cardInfo.cards[this.current].expand = false
                this.cardInfo.cards[idx].expand = true
                this.current = idx
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../common.scss';
</style>



// WEBPACK FOOTER //
// src/pages/sustainable/components/accordion.vue